<template>
    <div class="costTemplateWrap">
        <!-- // 费用明细列表 -->
        <div v-for="(jtem, jndex) in costTemplate.feeDetailList"
             :key="jndex"
             class="capacityOne">
            <div class="tbody">
                <p>{{jtem.feeName}}</p>
                <p style="margin-left: 14px;">{{$currencyUnit($getCookie('currency'))}}/{{jtem.unit === '票' ? $t('message.Itickets') : $t('message.kilogram')}}</p>
            </div>
            <div class="contentBox" :class="{priceEn: !$isZh()}">
                <div class="content" style="width: 130px;">
                    <span>{{$t('message.unitPrice')}} </span>
                    <span>{{$currencyAbbr($getCookie('currency')).split(' ')[0]}} {{jtem.unitPrice}}</span>
                </div>
                <p v-if="jtem.unit !== '票'" style="flex: 1;"><span v-if="jtem.minimumAmount" :style="{display: 'inline-block',width:!$isZh() ? '245px' : '165px'}">{{$t('message.iminimumcharge')}}{{jtem.minimumAmount}}{{$currencyUnit($getCookie('currency'))}}/{{$t('message.Itickets')}}</span><span v-if="jtem.maximumAmount">{{$t('message.maximumcharge')}}{{jtem.maximumAmount}}{{$currencyUnit($getCookie('currency'))}}/{{$t('message.Itickets')}}</span></p>
            </div>
        </div>
        <!-- // 仓储费用明细列表 危险品仓储费用明细列表 -->
        <div class="capacityTwo">
            <p class="tbody">{{$t('message.istoragefee')}}</p>
            <div v-for="(jtem, jndex) in costTemplate.cargofeeList"
                 :key="jndex">
                <div class="contentBox">
                    <div class="content" 
                         :class="{priceEn: !$isZh()}" 
                         style="justify-content: flex-start;">
                        <div style="display: flex;">
                            <p :style="{width:  !$isZh() ? '200px' : '56px'}">{{cargoTypeList[jtem.cargoType]}}</p>
                            <p :style="{marginLeft: '10px',width:!$isZh() ? '250px' : '130px'}">{{jtem.unitPrice}} {{$currencyUnit($getCookie('currency'))}}/{{$t('message.kilogram')}}/{{$t('message.day')}}</p>
                            <!-- <div v-else style="margin-left: 14px;">
                                <p class="tbodyp">{{`${jtem.level1.unitPrice}元/公斤/天（${jtem.level1.dayStart}-${jtem.level1.dayEnd}天）`}}</p>
                                <p class="tbodyp">{{`${jtem.level2.unitPrice}元/公斤/天（${jtem.level2.dayStart}-${jtem.level2.dayEnd}天）`}}</p>
                                <p class="tbodyp">{{`${jtem.level3.unitPrice}元/公斤/天（${jtem.level3.dayStart}天及以上）`}}</p>
                            </div> -->
                        </div>
                        <p :style="{marginTop: !$isZh() ? '18px' : '0'}" ><span v-if="jtem.minimumAmount" :style="{width:!$isZh() ? '250px' : '155px',display: 'inline-block'}">{{$t('message.iminimumcharge')}}{{jtem.minimumAmount}}{{$currencyUnit($getCookie('currency'))}}/{{jtem.cargoType === '0' ? $t('message.Itickets') : $t('message.day')}}</span><span v-if="jtem.maximumAmount" >{{$t('message.maximumcharge')}}{{jtem.maximumAmount}}{{$currencyUnit($getCookie('currency'))}}/{{$t('message.Itickets')}}</span></p>
                    </div>
                    <p :style="{marginLeft: !$isZh() ? '0' : '67px',marginTop: '12px'}"><span v-if="jtem.freeDays">本地免费保管{{jtem.freeDays}}{{$t('message.day')}}</span><span v-if="jtem.freeDays && jtem.otherCityfreeDays">/</span><span v-if="jtem.otherCityfreeDays">外地免费保管{{jtem.otherCityfreeDays}}{{$t('message.day')}}</span></p>
                </div>
            </div>
            <div v-for="(jtem, jndex) in costTemplate.dangerCargofeeList"
                 :key="jndex + 'a'">
                <div class="contentBox" :style="{marginTop: !$isZh() ? '0px' : '0px'}">
                    <div class="content">
                        <div :style="{display: 'flex',flexDirection:  !$isZh() ? 'column' : 'unset',alignItems: !$isZh() ? 'flex-start' : 'center'}">
                            <p :style="{width:!$isZh() ? '250px' : '56px',display: 'inline-block'}">{{cargoTypeList[jtem.cargoType]}}</p>
                            <!-- <p v-if="['0', '2', '5'].includes(jtem.cargoType)" style="margin-left: 14px;">{{jtem.unitPrice}} 元/公斤/天</p> -->
                            <div :style="{marginLeft: '10px',marginTop: !$isZh() ? '10px' : '0px'}">
                                <p class="tbodyp">{{`${jtem.level1.unitPrice}${$currencyUnit($getCookie('currency'))}/${$t('message.kilogram')}/${$t('message.day')}（${jtem.level1.dayStart}-${jtem.level1.dayEnd}${$t('message.day')}）`}}</p>
                                <p class="tbodyp">{{`${jtem.level2.unitPrice}${$currencyUnit($getCookie('currency'))}/${$t('message.kilogram')}/${$t('message.day')}（${jtem.level2.dayStart}-${jtem.level2.dayEnd}${$t('message.day')}）`}}</p>
                                <p class="tbodyp">{{`${jtem.level3.unitPrice}${$currencyUnit($getCookie('currency'))}/${$t('message.kilogram')}/${$t('message.day')}（${jtem.level3.dayStart}${$t('message.idaysandabove')}）`}}</p>
                            </div>
                        </div>                     
                    </div>
                    <p :style="{marginLeft: !$isZh() ? '0' : '67px'}"><span v-if="jtem.minimumAmount"  :style="{width:!$isZh() ? '250px' : '180px',display: 'inline-block'}">{{$t('message.iminimumcharge')}}{{jtem.minimumAmount}}{{$currencyUnit($getCookie('currency'))}}/{{jtem.cargoType === '0' ? $t('message.Itickets') : $t('message.day')}}</span><span v-if="jtem.maximumAmount" style="margin-left: 30px;">{{$t('message.maximumcharge')}}{{jtem.maximumAmount}}{{$currencyUnit($getCookie('currency'))}}/{{$t('message.Itickets')}}</span></p>
                    <p :style="{marginLeft: !$isZh() ? '0' : '67px',marginTop: '12px'}"><span v-if="jtem.freeDays">本地免费保管{{jtem.freeDays}}{{$currencyUnit($getCookie('currency'))}}</span><span v-if="jtem.freeDays && jtem.otherCityfreeDays">/</span><span v-if="jtem.otherCityfreeDays">外地免费保管{{jtem.otherCityfreeDays}}{{$t('message.day')}}</span></p>
                </div>
            </div>
        </div>
        <img  v-if="costTemplate.feeTemplateStatus === '0'"
              src="@/assets/img/personalCenter/operationCenter/cargoQuery/importBusiness/reviewing.png"
              class="reviewImg"
              alt="">
        <img  v-if="costTemplate.feeTemplateStatus === '2'"
              src="@/assets/img/personalCenter/operationCenter/cargoQuery/importBusiness/reviewNotPass.png"
              class="reviewImg"
              alt="">
    </div>
</template>
<script>
    export default {
        name: 'CostTemplate',// 模板列表
        props: {
            // 费用模板列表
            costTemplate: {
                type: Object,
                default: () => ({
                    feeTemplateId: '',// 费用模版Id
                    feeTemplateName: '',// 费用模版名称
                    feeTemplateStatus: '',// 费用模版状态 0-审核中、1-审核通过、2-审核不通过
                    feeDetailList: [],// 费用明细列表
                    cargofeeList: [],// 仓储费用明细列表
                    dangerCargofeeList: [],// 危险品仓储费用明细列表
                })
            },
        },
        data() {
            return {
                cargoTypeList: {
                    0: this.$t('message.generalGoods'),
                    1: this.$t('message.dangerousGoods'),
                    2: this.$t('message.coldCollection'),
                    5: this.$t('message.b5sdbzdasda'),
                    8: this.$t('message.dangerousColdGoods')
                }
            };
        },
        computed: {
            // 渲染的模板列表
            renderCostTemplate() {
                let newFeeList = JSON.parse(JSON.stringify(this.costTemplate));
                newFeeList.cargofeeList.push(...newFeeList.dangerCargofeeList);
                return newFeeList;
            }
        },
    };
</script>
<style lang="scss" scoped>
    .costTemplateWrap {
        position: relative;
        box-sizing: border-box;
        width: 590px;
        height: 700px;
        padding: 20px;
        overflow-y: scroll;
        border: 0 solid #aaa;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.28);

        // 操作费
        .capacityOne {
            margin-top: 12px;
            border: 1px solid #e8e8e8;

            .tbody {
                box-sizing: border-box;
                display: flex;
                width: 100%;
                height: 44px;
                padding: 12px 20px;
                background-color: #deeeff;
            }

            .contentBox {
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                padding: 15px 20px;

                .content {
                    box-sizing: border-box;
                }
            }

            .priceEn {
                flex-direction: column;
                align-items: flex-start;
            }
        }

        // 仓储费
        .capacityTwo {
            margin-top: 12px;
            border: 1px solid #e8e8e8;

            .tbody {
                box-sizing: border-box;
                width: 100%;
                height: 44px;
                padding: 12px 20px;
                background-color: #deeeff;
            }

            .contentBox {
                box-sizing: border-box;
                width: 100%;
                padding: 15px 20px;

                .content {
                    display: flex;
                    justify-content: space-between;

                    .tbodyp {
                        margin-bottom: 20px;
                    }
                }
            }

            .priceEn {
                flex-direction: column;
                align-items: flex-start;
            }
        }

        // 审核图片
        .reviewImg {
            position: absolute;
            right: 66px;
            bottom: 46px;
        }
    }

    .costTemplateWrap::-webkit-scrollbar {
        display: none;
    }
</style>